import { useContext } from "react";

import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import store from "@beeldit/core/services/store";
import { CreateActionContext } from "./CreateActionContext";
import Swal from "sweetalert2";

function useStore(modelConfig: any) {
  const { element, setBackendFormErrors, setLoading } = useContext(CreateActionContext);
  const errorHandler = useErrorHandler();
  
  const performStore = (dataToSend: any, onSuccess: any) => {
    setLoading(true);
    store(modelConfig.endpoint, dataToSend)
      .then((response: any) => {
        setLoading(false);
        onSuccess(response.data);
      })
      .catch((error: any) => {
        console.error("Error fetching data:", error);
        setLoading(false);
        
        // IMPORTANTE: Verificar festivos ANTES de llamar errorHandler (que hace return en 422)
        if (error.response?.status === 422) {
          const errors = error.response?.data?.errors;
          
          const hasHolidayError = 
            (errors?.start_date_time?.some((msg: string) => msg.includes("festivo"))) ||
            (errors?.end_date_time?.some((msg: string) => msg.includes("festivo")));
          
          if (hasHolidayError) {
            // Determinar qué fecha es festiva
            let holidayMessage = "Ha seleccionado un día festivo";
            const holidayDates = [];
            
            if (errors?.start_date_time?.some((msg: string) => msg.includes("festivo"))) {
              holidayDates.push(`fecha de inicio (${new Date(element.start_date_time).toLocaleDateString('es-ES')})`);
            }
            if (errors?.end_date_time?.some((msg: string) => msg.includes("festivo"))) {
              holidayDates.push(`fecha de fin (${new Date(element.end_date_time).toLocaleDateString('es-ES')})`);
            }
            
            if (holidayDates.length > 0) {
              holidayMessage += ` para la ${holidayDates.join(' y la ')}`;
            }
            holidayMessage += ". ¿Estás seguro que deseas realizar la reserva?";
            
            // Mostrar modal de confirmación
            Swal.fire({
              title: 'Día festivo',
              text: holidayMessage,
              icon: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Sí, continuar',
              cancelButtonText: 'Cancelar',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
            }).then((result) => {
              if (result.isConfirmed) {
                // Reintentar con force_holidays: true
                const dataWithForce = { ...element, force_holidays: true };
                performStore(dataWithForce, onSuccess);
              }
            });
            return; // IMPORTANTE: return aquí para NO llamar errorHandler
          }
        }
        
        // Si no es error de festivos, manejar error normalmente
        errorHandler(error, setBackendFormErrors);
      });
  };
  
  return (onSuccess: any) => {
    performStore(element, onSuccess);
  };
}

export default useStore;
